import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  generatedInvites: {},
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.INVITES_LOADED: {
      const { invites } = action.payload;

      result = _.assign({}, state, {
        generatedInvites: _.keyBy(invites, 'id'),
      });
      break;
    }

    case actionTypes.INVITE_GENERATED: {
      const { invite } = action.payload;

      result = _.assign({}, state);
      result.generatedInvites[invite.id] = invite;
      break;
    }

    case actionTypes.INVITE_REVOKED: {
      const { inviteId } = action.payload;

      result = _.assign({}, state);
      delete result.generatedInvites[inviteId];
      break;
    }

    default: {
      result = _.assign({}, state);
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/invites.js